import { render, staticRenderFns } from "./AssignedTasksList.vue?vue&type=template&id=249eb542"
import script from "./AssignedTasksList.vue?vue&type=script&lang=js"
export * from "./AssignedTasksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports